import VTreeview from './VTreeview';
import VTreeviewNode from './VTreeviewNode';
export { VTreeview, VTreeviewNode };
export default {
  $_vuetify_subcomponents: {
    VTreeview,
    VTreeviewNode
  }
};
//# sourceMappingURL=index.js.map